/**
 * ERP Core API — assets, timeoff, offboarding.
 */

import { apiFetch } from './core'

export const erp = {
    keys: {
        list: (params = {}) => {
            const qs = new URLSearchParams(params).toString()
            return apiFetch(`/erp/keys${qs ? `?${qs}` : ''}`)
        },
        get: (keyId) => apiFetch(`/erp/keys/${keyId}`),
        create: (data) => apiFetch('/erp/keys', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        assign: (keyId, employeeId) => apiFetch(`/erp/keys/${keyId}/assign?employee_id=${employeeId}`, { method: 'PATCH' }),
        unassign: (keyId) => apiFetch(`/erp/keys/${keyId}/unassign`, { method: 'PATCH' }),
        update: (keyId, data) => apiFetch(`/erp/keys/${keyId}`, {
            method: 'PUT',
            body: JSON.stringify(data),
        }),
        delete: (keyId) => apiFetch(`/erp/keys/${keyId}`, { method: 'DELETE' }),
        // Key passport — chronological events: acquired, assigned, returned,
        // blocked, unblocked, lost, stolen, written_off, disposed,
        // inventory_check, note.
        events: {
            list: (keyId) => apiFetch(`/erp/keys/${keyId}/events`),
            create: (keyId, data) => apiFetch(`/erp/keys/${keyId}/events`, {
                method: 'POST',
                body: JSON.stringify(data),
            }),
            delete: (keyId, eventId) => apiFetch(`/erp/keys/${keyId}/events/${eventId}`, { method: 'DELETE' }),
        },
    },
    assets: {
        list: (params = {}) => {
            const qs = new URLSearchParams(params).toString()
            return apiFetch(`/erp/assets${qs ? `?${qs}` : ''}`)
        },
        get: (assetId) => apiFetch(`/erp/assets/${assetId}`),
        create: (data) => apiFetch('/erp/assets', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        assign: (assetId, employeeId) => apiFetch(`/erp/assets/${assetId}/assign?employee_id=${employeeId}`, { method: 'PATCH' }),
        unassign: (assetId) => apiFetch(`/erp/assets/${assetId}/unassign`, { method: 'PATCH' }),
        update: (assetId, data) => apiFetch(`/erp/assets/${assetId}`, {
            method: 'PUT',
            body: JSON.stringify(data),
        }),
        delete: (assetId) => apiFetch(`/erp/assets/${assetId}`, { method: 'DELETE' }),
        // ITAM lifecycle passport — chronological events: acquired, assigned,
        // returned, sent_to_repair, returned_from_repair, breakdown_reported,
        // lost, stolen, written_off, disposed, inventory_check, note.
        events: {
            list: (assetId) => apiFetch(`/erp/assets/${assetId}/events`),
            create: (assetId, data) => apiFetch(`/erp/assets/${assetId}/events`, {
                method: 'POST',
                body: JSON.stringify(data),
            }),
            delete: (assetId, eventId) => apiFetch(`/erp/assets/${assetId}/events/${eventId}`, { method: 'DELETE' }),
        },
    },
    // Canonical office list (mirror of constants/offices.js, served from backend).
    offices: {
        list: () => apiFetch('/erp/offices'),
    },
    // Cabinet/rack dictionary (Шкаф/стеллаж) — managed per office.
    storageUnits: {
        list: (officeId) => apiFetch(`/erp/storage-units${officeId ? `?office_id=${encodeURIComponent(officeId)}` : ''}`),
        create: (data) => apiFetch('/erp/storage-units', { method: 'POST', body: JSON.stringify(data) }),
        rename: (id, name) => apiFetch(`/erp/storage-units/${id}`, { method: 'PATCH', body: JSON.stringify({ name }) }),
        delete: (id) => apiFetch(`/erp/storage-units/${id}`, { method: 'DELETE' }),
    },
    // Per-user office/creator inventory visibility grants (admin-managed).
    inventoryVisibility: {
        listGrants: () => apiFetch('/erp/inventory-visibility/grants'),
        getGrant: (userId) => apiFetch(`/erp/inventory-visibility/grants/${userId}`),
        putGrant: (userId, data) => apiFetch(`/erp/inventory-visibility/grants/${userId}`, {
            method: 'PUT',
            body: JSON.stringify(data),
        }),
        deleteGrant: (userId) => apiFetch(`/erp/inventory-visibility/grants/${userId}`, { method: 'DELETE' }),
    },
    timeoff: {
        list: (params = {}) => {
            const qs = new URLSearchParams(params).toString()
            return apiFetch(`/erp/timeoff${qs ? `?${qs}` : ''}`)
        },
        create: (data) => apiFetch('/erp/timeoff', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        approve: (id, approvedById) => apiFetch(`/erp/timeoff/${id}/approve?approved_by_id=${approvedById}`, { method: 'POST' }),
        reject: (id, reason = '') => apiFetch(`/erp/timeoff/${id}/reject?reason=${encodeURIComponent(reason)}`, { method: 'POST' }),
        balance: (employeeId, year = 2026) => apiFetch(`/erp/timeoff/balance/${employeeId}?year=${year}`),
    },
    offboarding: {
        initiate: (employeeId) => apiFetch(`/erp/offboarding/${employeeId}`, { method: 'POST' }),
        get: (employeeId) => apiFetch(`/erp/offboarding/${employeeId}`),
        completeTask: (taskId) => apiFetch(`/erp/offboarding/tasks/${taskId}/complete`, { method: 'POST' }),
    },
}
